import { render, staticRenderFns } from "./legalBank.vue?vue&type=template&id=43acacc2&scoped=true&"
import script from "./legalBank.vue?vue&type=script&lang=js&"
export * from "./legalBank.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/css/content.css?vue&type=style&index=0&id=43acacc2&scoped=true&lang=css&"
import style1 from "./legalBank.vue?vue&type=style&index=1&id=43acacc2&scoped=true&lang=less&"
import style2 from "./legalBank.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43acacc2",
  null
  
)

export default component.exports